import { render, staticRenderFns } from "./MatchResultConsole.vue?vue&type=template&id=e717e0b2&"
import script from "./MatchResultConsole.vue?vue&type=script&lang=js&"
export * from "./MatchResultConsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports